module.exports = __webpack_public_path__ + "static/media/syracuse_univ_flag.b9258772.png";